import React from 'react';
import {Textbox, LinkVideoStage, DictionaryVideoStage} from '../../types';
import Link from './Link/link';

type Props = {
  textbox: Textbox;
  dictionary?: DictionaryVideoStage;
  link?: LinkVideoStage;
  paused: boolean;
  toggleVideoPlay: () => void
}

const TextBoxMuted = (props: Props): JSX.Element => {
  const {textbox, dictionary, link, paused, toggleVideoPlay} = props;
  const playLabelFallBack = 'Hintergrundvideo starten';
  const pauseLabelFallBack = 'Hintergrundvideo pausieren';
  const ariaLabel: string = paused ? dictionary?.playButtonLabel || playLabelFallBack : dictionary?.pauseButtonLabel || pauseLabelFallBack ;
  return (
    <div className={`stage-gallery__text-box ${textbox.position} high-stage video-text-box `}>
      <button type='button' tabIndex={0} aria-label={ariaLabel} onClick={toggleVideoPlay}
              className='btn-play-pause'>
        {
          paused ?
            <span className="ic-play" aria-hidden="true"/> :
            <span className="ic-pause" aria-hidden="true"/>
        }
      </button>
      <span className="icon ic-arrowsRight stage-gallery__text-icon" aria-hidden="true"/>
      <div className="link-headline__wrapper hl-3">
        <Link link={link}>
          <p className="hl-3 topic-stage-headline">{textbox.title}</p>
        </Link>
      </div>
    </div>
  );
}

export default TextBoxMuted;
